import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import withColumnCounter from '../../withColumnCounter'
import PathologyBox from './PathologyBox/PathologyBox'
import ShotVirtualContainer from './ShotVirtualContainer/ShotVirtualContainer'

import './PathologiesGrid.css'
import moment from 'moment'
import withPolyglot from '../../../../common/withPolyglot'

class PathologiesGrid extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  // componentDidUpdate () {
  //   const { visiblePathologyId, visibleImmunizations, visibleRecommendations } = this.state
  //   console.log(visiblePathologyId)
  //   if (visiblePathologyId && !(visibleImmunizations + visibleRecommendations)) {
  //     const immunizations = this.getImmunizationsForPathology(visiblePathologyId)
  //     const recommendations = this.getRecommendationsForPathology(visiblePathologyId)
  //     this.setState({
  //       visibleImmunizations: immunizations,
  //       visibleRecommendations: recommendations,
  //     })
  //   }
  // }

  pathologyClickHandle (pathologyId, pathologyKey, isClicked) {
    if (isClicked) {
      this.props.removeSelectedPathology()
    } else {
      this.props.selectPathology(pathologyKey)
    }
  }

  getImmunizationsForPathology (pathologyId) {
    const pathology = this.props.pathologies.find(p => p.id === pathologyId)
    return pathology.immunizations
  }
  getRecommendationsForPathology (pathologyId) {
    const pathology = this.props.pathologies.find(p => p.id === pathologyId)
    return pathology.recommendations
  }
  getPlannedShotsForPathology (pathologyId) {
    const pathology = this.props.pathologies.find(p => p.id === pathologyId)
    return pathology.plannedShots
  }

  isPlannedShotInFuture (patientBirth, val, unit) {
    const birth = moment(new Date(patientBirth))
    const shotDate = moment(birth).add(val, unit)
    const today = moment()
    if (today.isAfter(shotDate)) {
      return 'late'
    } else return 'future'
  }

  getPathologyStatus (pathology) {
    let status = 'ok'
    for (let recommendation of pathology.recommendations) {
      const earliest = moment(new Date(recommendation.dateCriterion.earliest))
      const latest = moment(new Date(recommendation.dateCriterion.latest))
      const today = moment()
      if (today.isBetween(earliest, latest)) {
        status = 'present'
        break
      } else if (today.isAfter(latest)) {
        status = 'late'
        break
      }
    }
    for (let planned of pathology.plannedShots) {
      const status = this.isPlannedShotInFuture(this.props.patientBirthDate, planned.val, planned.unit)
      if (status !== 'future') {
        return status
      }
    }
    return status
  }

  hasImmunoglobulin (immunizations) {
    return !!immunizations.find(immuno => immuno.type === 'immunoglobulin')
  }

  renderPathology (pathology, key) {
    // TODO Status need to be modified
    const hasImmunoglobulin = this.hasImmunoglobulin(pathology.immunizations)
    const status = hasImmunoglobulin ? 'attention' : this.getPathologyStatus(pathology)
    let isActive = true
    const hasClickedItem = this.props.selectedPathology !== undefined
    if (hasClickedItem && this.props.selectedPathology !== key) {
      isActive = false
    }
    const {immunizations, recommendations} = pathology
    const currentShots = immunizations.filter(immunization => immunization.type !== 'immunoglobulin')
    const total = pathology.entries.length === 0 ? currentShots.length : pathology.entries.length
    const shots = {
      current: currentShots.length,
      total
    }
    // TODO put shortName if screen smaller then n(?)
    return <PathologyBox
      hasImmunoglobulin={hasImmunoglobulin}
      shots={shots}
      isActive={isActive}
      pathologyClickHandle={(isClicked) => this.pathologyClickHandle(pathology.id, key, isClicked && hasClickedItem)}
      status={status}
      nextRecommendation={recommendations[0]}
      key={key}
      displayKey={pathology.displayKey} />
  }

  renderPathologyWithShotContainer (pathology, key, responsibleFor) {
    return <Fragment key={key}>
      {this.renderPathology(pathology, key)}
      {this.renderShotContainer(responsibleFor)}
    </Fragment>
  }

  renderShotContainer (responsibleFor) {
    const visibleImmunizations = this.props.selectedPathology ? this.getImmunizationsForPathology(this.props.selectedPathology) : []
    const visibleRecommendations = this.props.selectedPathology ? this.getRecommendationsForPathology(this.props.selectedPathology) : []
    const visiblePlannedShots = this.props.selectedPathology ? this.getPlannedShotsForPathology(this.props.selectedPathology) : []
    return <div className='uk-width-1-1'>
      {responsibleFor.includes(this.props.selectedPathology)
        ? <ShotVirtualContainer
          editMode={this.props.editMode}
          patientBirthDate={this.props.patientBirthDate}
          immunizations={visibleImmunizations}
          recommendations={visibleRecommendations}
          planned={visiblePlannedShots} />
        : null
      }
    </div>
  }
  renderGridContent (pathologies) {
    const {columns} = this.props
    let responsibleFor = []
    return pathologies.map((pathology, index) => {
      if (pathology.hasElements()) {
        if ((index === pathologies.length - 1) || ((index + 1) % columns === 0 && index > 0)) {
          responsibleFor.push(pathology.id)
          const result = this.renderPathologyWithShotContainer(pathology, pathology.id, responsibleFor)
          responsibleFor = []
          return result
        } else {
          responsibleFor.push(pathology.id)
          return this.renderPathology(pathology, pathology.id)
        }
      } else return null
    })
  }

  render () {
    const { columns, pathologies } = this.props
    if (columns > 0) {
      return <div
        className='pathology-grid uk-grid-small uk-grid uk-child-width-1-2 uk-child-width-1-3@s uk-child-width-1-4@m uk-child-width-1-6@l'
        data-uk-grid data-uk-height-match>
        {this.renderGridContent(pathologies)}
      </div>
    } else return null
  }
}

PathologiesGrid.propTypes = {
  editMode: PropTypes.bool,
  columns: PropTypes.number,
  pathologies: PropTypes.array.isRequired
}

PathologiesGrid.defaultProps = {
  editMode: false
}

const translatedComponent = withPolyglot(PathologiesGrid, 'pathologiesGrid')

export default withColumnCounter(translatedComponent)
